import React from "react";
import { TouchableOpacity, Text, StyleSheet, TextInput } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import * as Colors from "../styles/colors";
import * as Fonts from "../styles/typography";

export default function IconButton({
  textoBotao,
  iconName,
  estilo,
  onPress,
  disabled = false,
}) {
  return (
    <TouchableOpacity
      style={[styles.botao, estilo]}
      onPress={onPress}
      disabled={disabled}
    >
      <Icon
        style={styles.icon}
        name={iconName}
        size={27}
        color={Colors.WHITE}
      />
      <Text style={styles.estiloTexto} numberOfLines={1} ellipsizeMode="tail">  {textoBotao}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  botao: {
    borderRadius: 8,
    alignItems: "center",
    paddingVertical: 8,
    paddingHorizontal: 8,
    height: 50,
    justifyContent: "center",
    width: "70%",
    backgroundColor: Colors.PRIMARY
  },
  estiloTexto: {
    color: Colors.TEXTOBOTAO,
    fontSize: Fonts.FONT_SIZE_20,
    letterSpacing: 1,
    lineHeight: Fonts.FONT_SIZE_25,
    fontWeight: "bold",
    marginLeft: 16,
  },
  estiloBotao: {
    height: 50,
    justifyContent: "center",
  },
  icon: {
    position: "absolute",
    left: 10,
  },
});
